package uz.mint.frontend.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import uz.mint.frontend.components.layouts.PageLayoutData
import uz.mint.frontend.components.sections.MyEsimsPage
import uz.mint.frontend.i18n.Locale
import uz.mint.frontend.i18n.accountStringsFor

/** My eSIMs in Russian, the default locale, at /esims. */
private val LOCALE = Locale.RU

@InitRoute
fun initEsimsRoutePage(ctx: InitRouteContext) {
    val account = accountStringsFor(LOCALE)
    ctx.data.add(PageLayoutData(account.esimsMetaTitle, LOCALE, account.esimsMetaDescription))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun EsimsRoutePage() {
    MyEsimsPage(LOCALE)
}
